const Click = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2C8.8203 2 3 7.8203 3 15C3 21.2223 7.3725 26.4256 13.2133 27.7008L14.1903 27.9141L13.7637 29.8681L12.7867 29.6548C6.04677 28.1833 1 22.1822 1 15C1 6.71573 7.71573 0 16 0C23.1822 0 29.1833 5.04677 30.6548 11.7867L30.8681 12.7637L28.9141 13.1903L28.7008 12.2133C27.4256 6.3725 22.2223 2 16 2Z"
        fill={color}
      />
      <path
        d="M26.0011 30.1265L20.2446 24.37L16.3737 28.2409L14.8789 13.8777L29.242 15.3725L25.3711 19.2434L31.1276 25L26.0011 30.1265Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 8C12.134 8 9 11.134 9 15C9 17.5897 10.4058 19.8523 12.5007 21.0641L13.3663 21.5649L12.3649 23.2961L11.4993 22.7953C8.81178 21.2407 7 18.3325 7 15C7 10.0294 11.0294 6 16 6C19.3325 6 22.2407 7.81178 23.7953 10.4993L24.2961 11.3649L22.5649 12.3663L22.0641 11.5007C20.8523 9.4058 18.5897 8 16 8Z"
        fill={color}
      />
    </svg>
  );
};
export default Click;
